import { prefixEvent, getCSSVariable } from './helpers';

export const BrowserEvents = {
	lazyload: 'lazyload.refresh',
	resize: 'resize',
	page: {
		enter: 'page.enter',
		leave: 'page.leave',
		transition: 'page.transition',
	},
	transition: {
		start: prefixEvent('Transition', 'Start'),
		end: prefixEvent('Transition', 'End'),
	},
	animation: {
		start: prefixEvent('Animation', 'Start'),
		end: prefixEvent('Animation', 'End'),
		refresh: 'animation.refresh'
	},
	disclaimer: {
		accepted: 'disclaimer.accepted',
	},
};

export const BrowserEventsPromises = {
	transition: {
		start: (element) => new Promise((resolve, reject) => jQuery(element).one(BrowserEvents.transition.start, resolve)),
		end: (element) => new Promise((resolve, reject) => jQuery(element).one(BrowserEvents.transition.end, resolve)),
	},
	animation: {
		start: (element) => new Promise((resolve, reject) => jQuery(element).one(BrowserEvents.animation.start, resolve)),
		end: (element) => new Promise((resolve, reject) => jQuery(element).one(BrowserEvents.animation.end, resolve)),
	}
};

export const Breakpoints = {
	xs: parseInt(getCSSVariable('--breakpoint-xs'), 10),
	sm: parseInt(getCSSVariable('--breakpoint-sm'), 10),
	md: parseInt(getCSSVariable('--breakpoint-md'), 10),
	lg: parseInt(getCSSVariable('--breakpoint-lg'), 10),
	xl: parseInt(getCSSVariable('--breakpoint-xl'), 10),
	Mobile: parseInt(getCSSVariable('--mobile-breakpoint'), 10),
	Menu: parseInt(getCSSVariable('--menu-breakpoint'), 10),
};

export const Elements = {
	get LoadingBar() {
		return document.querySelector('.loading-bar');
	},
	get LoadingOverlay() {
		return document.querySelector('.loading-overlay');
	},
	get MainWrapper() {
		return document.querySelector('.main-wrapper');
	},
	get MenuWrapper() {
		return document.querySelector('.menu-wrapper');
	},
	get HeaderWrapper() {
		return document.querySelector('.header-wrapper');
	},
};

export const $Elements = {
	window: jQuery(window),
	document: jQuery(document),
	html: jQuery('html'),
	body: jQuery('body'),
	LoadingBar: jQuery(Elements.LoadingBar),
	LoadingOverlay: jQuery(Elements.LoadingOverlay),
	MainWrapper: jQuery(Elements.MainWrapper),
	MenuWrapper: jQuery(Elements.MenuWrapper),
	HeaderWrapper: jQuery(Elements.HeaderWrapper),
};

export const Classes = {
	active: 'active',
	leaving: 'leaving',
	loading: 'loading',
	loaded: 'loaded',
	hidden: 'd-none',
	invisible: 'invisible',
	show: 'show',
	disclaimer: 'disclaimer-open',
	menuOpen: 'menu-open',
	menuLight: 'menu-light',
	menuClosing: 'menu-closing',
};

export const TransitionDurations = {
	default: 750,
};

export const Durations = {
	default: {
		ms: parseInt(getCSSVariable('--transition-duration'), 10),
		s: parseInt(getCSSVariable('--transition-duration'), 10) / 1000,
	},
	page: {
		ms: parseInt(getCSSVariable('--page-transition-duration'), 10),
		s: parseInt(getCSSVariable('--page-transition-duration'), 10) / 1000,
	},
	animations: {
		ms: parseInt(getCSSVariable('--animations-duration'), 10),
		s: parseInt(getCSSVariable('--animations-duration'), 10) / 1000,
	},
};

export const GoogleMapsStyles = [
	{
		"featureType": "administrative",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#444444"
			}
		]
	},
	{
		"featureType": "landscape",
		"elementType": "all",
		"stylers": [
			{
				"color": "#f2f2f2"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [
			{
				"saturation": -100
			},
			{
				"lightness": 45
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "simplified"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [
			{
				"color": "#dedede"
			},
			{
				"visibility": "on"
			}
		]
	}
];
